/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteInvoicesZohoRequest } from '../models/DeleteInvoicesZohoRequest';
import type { DeletePaymentsZohoRequest } from '../models/DeletePaymentsZohoRequest';
import type { PostItemsZohoRequest } from '../models/PostItemsZohoRequest';
import type { PostPackagesZohoRequest } from '../models/PostPackagesZohoRequest';
import type { PostPaymentsApplyZohoRequest } from '../models/PostPaymentsApplyZohoRequest';
import type { PostPaymentsZohoRequest } from '../models/PostPaymentsZohoRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ZohosService {
    /**
     * **Required Policy:** `ManageUsers`
     * @returns any OK
     * @throws ApiError
     */
    public static postBranchAdmin({
        branchId,
    }: {
        branchId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/create-branch',
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUsers`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchAdmin({
        branchId,
    }: {
        branchId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/update-branch',
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItems`
     * @returns any OK
     * @throws ApiError
     */
    public static postSubmitToZohoAdmin({
        requestBody,
    }: {
        requestBody?: PostItemsZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/items/submit-to-zoho',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItems`
     * @returns any OK
     * @throws ApiError
     */
    public static putItemsOnZohoAsyncAdmin({
        requestBody,
    }: {
        requestBody?: PostItemsZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/items/update-on-zoho',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postInvoiceByDateAdmin({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/invoices/by-date',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postInvoiceAdmin({
        requestBody,
    }: {
        requestBody?: PostPaymentsZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/invoices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteInvoiceAdmin({
        requestBody,
    }: {
        requestBody?: DeleteInvoicesZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/zohos/invoices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postPaymentsByDateAdmin({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/payments/by-date',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postPaymentsAdmin({
        requestBody,
    }: {
        requestBody?: PostPaymentsZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static deletePaymentsAdmin({
        requestBody,
    }: {
        requestBody?: DeletePaymentsZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/zohos/payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postPaymentsApplyByDateAdmin({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/apply-payments-by-date',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postPaymentsApplyAdmin({
        requestBody,
    }: {
        requestBody?: PostPaymentsApplyZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/apply-payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postInvoiceFulfillmentPaymentAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/invoice-fulfillments/{id}/payment',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteInvoiceFulfillmentPaymentAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/zohos/invoice-fulfillments/{id}/payment',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackageInvoicesAdmin({
        requestBody,
    }: {
        requestBody?: PostPackagesZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/packages/invoices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static deletePackageInvoicesAdmin({
        requestBody,
    }: {
        requestBody?: PostPackagesZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/zohos/packages/invoices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postPackagePaymentsAdmin({
        requestBody,
    }: {
        requestBody?: PostPackagesZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/packages/payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static deletePackagePaymentsAdmin({
        requestBody,
    }: {
        requestBody?: PostPackagesZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/zohos/packages/payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePackages`
     * @returns any OK
     * @throws ApiError
     */
    public static postApplyPackagePaymentsAdmin({
        requestBody,
    }: {
        requestBody?: PostPackagesZohoRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zohos/packages/apply-payments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
